/**
 * Common icon mapping for menu items and module entries
 * Maps icon identifiers to their corresponding emoji icons
 */

export const iconMap: Record<string, string> = {
    // Navigation path based icons
    '/home': '🏠',
    '/tischkonten': '🏦',
    '/schedule': '📜',
    '/meetups': '📅',
    '/chat': '💬',
    '/pictures': '📷',
    '/participants': '👥',
    '/share': '🔗',
    '/announcements': '📢',
    '/sharing': '📤',
    '/statistics': '📊',
    '/notifications': '🔔',
    '/feedback': '📩',
    '/faq': '❓',
    '/logout': '🚪',
    '/switch': '🔄',
    '/date': '❤️',
    '/contact-links': '📞',
    '/projects': '📋',
    '/subscriptions': '🧾',
    
    // Icon ID based mapping
    'code': '🔑',
    'settings': '⚙️',
    'event': '🎉',
    'home': '🏠',
    'schedule': '📜',
    'meetups': '📅',
    'chat': '💬',
    'pictures': '📷',
    'participants': '👥',
    'share': '🔗',
    'announcements': '📢',
    'sharing': '📤',
    'statistics': '📊',
    'notifications': '🔔',
    'feedback': '📩',
    'faq': '❓',
    'date': '❤️',
    'food': '🍽️',
    'location': '📍',
    'transport': '🚗',
    'music': '🎵',
    'games': '🎮',
    'sports': '⚽',
    'awards': '🏆',
    'network': '🤝',
    'workshop': '🛠️',
    'presentation': '📊',
    'business': '💼',
    'charity': '❤️‍🩹',
    'registration': '📝',
    'contact': '📞',
    'calendar': '📅',
    'switch': '🔄',
    'contact_links': '📞',
    'projects': '📋',
    'subscriptions': '🧾',
    
    // Default fallback
    'default': '📄'
};

/**
 * Get icon for a given identifier
 * @param iconId - The icon identifier
 * @returns The corresponding emoji icon or default icon
 */
export const getIcon = (iconId: string): string => {
    return iconMap[iconId] || iconMap['default'];
};
